
import { Model } from "@/utils/models/model";
import { Highlight } from "@/utils/views/highlight";
import Vue from "vue";
import AppBrowseConditionEdit from "@/components/models/BrowseConditionEdit.vue";
import { Condition, Operator } from "@/utils/condition/condition";
import { Browse } from "@/models/browse";

export default Vue.extend({
	data(){
		return {
			selectedConditionIndex: 0
		};
	},
	props: {
		highlight: {
			type: Object as ()=>Highlight,
			required: true
		},
		model: {
			type: Object as ()=>Model,
			required: true
		},
		browse: {
			type: Object as ()=>Browse,
			required: true
		}
	},
	computed: {
		selectedCondition():Condition | undefined {
			return this.highlight.Conditions[this.selectedConditionIndex];
		}
	},
	methods: {
		getConditionAsString(condition:Condition):string{
			return condition.conditionToShortString(Highlight.makeGetFieldNameFunc(this.model));
		},
		removeCondition(i:number){
			this.highlight.Conditions.splice(i, 1);
			if (this.selectedConditionIndex >= this.highlight.Conditions.length){
				this.selectedConditionIndex = this.highlight.Conditions.length-1;
			}
		},
		addCondition(){
			let condition = new Condition();
			condition.Prop = this.model.getBrowseFields()[0].path;
			condition.Operator = Operator.IS_EMPTY;
			this.highlight.Conditions.push(condition);
			this.selectedConditionIndex = this.highlight.Conditions.length-1;
		}
	},
	components: {
		AppBrowseConditionEdit
	},
	i18nEx: {
		componentPrefix: "components.view-editor"
	}
});
